import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[pwdValidateDirective]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PwdValidatorDirective,
    multi: true
  }]
})
export class PwdValidatorDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) return { 'pwdEmptyInvalid': true }
    const anUpperCase = /[A-Z]/;
    const aLowerCase = /[a-z]/;
    const aNumber = /[0-9]/;
    // const aSpecial = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

    let numUpper = 0;
    let numLower = 0;
    let numNums = 0;

    let res = {
      pwdInvalidLength: false,
      pwdInvalidMinReq: false
    }

    if (control.value.length < 8 || control.value.length > 16) {
      res.pwdInvalidLength = true;
    }

    for (let i = 0; i < control.value.length; i++) {
      if (anUpperCase.test(control.value[i]))
        numUpper++;
      else if (aLowerCase.test(control.value[i]))
        numLower++;
      else if (aNumber.test(control.value[i]))
        numNums++;
    }

    if (numUpper < 1 || numLower < 1 || numNums < 1) {
      res.pwdInvalidMinReq = true;
    }
    if (!res.pwdInvalidLength && !res.pwdInvalidMinReq)
      return null;
    else
      return res;
  }
}